import { uniq, orderBy } from 'lodash'
import { mapperToOptions } from '@/views/components/selects'
import {
    mapperSectionsToOptions,
    mapperStatusToOptions,
} from '@/views/components/fields'
import {
    formatDate,
    getDateFromStringWithoutTime as getDateFromString,
} from '@/lib/date'

const mapperOptionsToApi = options => options.map(option => option.value)

export function mapperFormToApi(data) {
    const {
        rows,
        title,
        calibration_type,
        x_target_value,
        y_target_value,
        axis_y,
        axis_x,
        columns,
        quadrants,
        periods,
        status,
        teams,
        admission_date,
        occupation_groups,
    } = data
    return {
        title,
        rows,
        columns,
        quadrants,
        x_target_value,
        y_target_value,
        calibration_type,
        title_x: axis_x.title,
        title_y: axis_y.title,
        teams: mapperOptionsToApi(teams),
        status: mapperOptionsToApi(status),
        periods: mapperOptionsToApi(periods),
        occupation_groups: mapperOptionsToApi(occupation_groups),
        variables: axis_x.variables.concat(axis_y.variables),
        admission_date: admission_date
            ? formatDate(admission_date, 'YYYY-MM-DD')
            : null,
    }
}

const getAxisLimits = (quadrants, axis) => {
    let limits = quadrants.reduce(
        (array, q) => array.concat([q[`${axis}_min`], q[`${axis}_max`]]),
        []
    )
    limits = uniq(limits)
    return orderBy(limits)
}

export function mapperApiToForm(data) {
    const {
        rows,
        teams,
        title,
        status,
        title_x,
        title_y,
        columns,
        periods,
        variables,
        quadrants,
        x_target_value,
        y_target_value,
        calibration_type,
        occupation_groups,
        admission_date,
    } = data
    return {
        title,
        rows,
        columns,
        quadrants,
        x_target_value,
        y_target_value,
        calibration_type,
        admission_date: admission_date
            ? getDateFromString(admission_date, 'YYYY-MM-DD')
            : null,
        status: mapperStatusToOptions(status),
        teams: mapperSectionsToOptions(teams),
        periods: mapperToOptions(periods, undefined, 'name'),
        occupation_groups: mapperToOptions(
            occupation_groups,
            undefined,
            'name'
        ),
        limits: {
            x: getAxisLimits(quadrants, 'x'),
            y: getAxisLimits(quadrants, 'y'),
        },
        axis_x: {
            title: title_x,
            variables: variables.filter(v => v.axis == 'x'),
        },
        axis_y: {
            title: title_y,
            variables: variables.filter(v => v.axis == 'y'),
        },
    }
}
